import Image from "components/common/Image";
import { lifeChoiseDetailsDesktop } from "constantVariables";
import useMediaQuery from "hooks/useMediaQuery";
import React, { FC } from "react";
import { ITechnicalSkillModal } from "types/components/technicalSkillModal";
import styles from "./index.module.scss";
import { useAppSelector } from "store/hooks";
import { getSettings } from "store/slices";

const TechnicalSkillModal: FC<ITechnicalSkillModal> = ({ skill }) => {
  const isDesktop = useMediaQuery(lifeChoiseDetailsDesktop);
  const { dir, language } = useAppSelector(getSettings);
  const imageIndex =
    skill.media.length > 1
      ? Math.floor(Math.random() * (skill.media.length - 1))
      : 0;
  const SSImage = skill.media?.[imageIndex];

  return (
    <div className={styles["content"]}>
      <h3 className="text-xl text-theme-blue text-bold">
        {skill.title[language]}
      </h3>
      <p dir={dir}>{skill.description[language]}</p>
      {SSImage ? (
        <Image
          src={process.env.REACT_APP_CLOUDFRONT_URL + SSImage}
          skeletonOptions={{
            height: isDesktop ? "300px" : "200px",
          }}
          className="max-h-64"
        />
      ) : (
        ""
      )}
    </div>
  );
};

export default TechnicalSkillModal;
